import Boosts from "./containers/Desktop";

export default Boosts;



// WEBPACK FOOTER //
// ./src/apps/boosts/index.js